import { Component } from 'react';

export default class ScrollToTopOnMount extends Component {
	componentDidMount(prevProps) {
		window.scrollTo(0, 0)
	}

	render() {
		return null
	}
}


// WEBPACK FOOTER //
// ./src/elements/scroll_top.jsx